import { useAppSelector } from 'redux/use-hooks';
import {
  selectTotalBalance,
  selectPlantedOPN,
  selectCollectAvailable,
  selectRewardsAvailable, selectPlantedUnLockedOPN, selectPlantedLockedOPN, selectPlantedWithdrawAt
} from 'redux/slices/tokens';

import BalanceCardSmallIcon from 'components/icons/BalanceCardSmallIcon';
import WithdrawSmallIcon from 'components/icons/WithdrawSmallIcon';
import CollectSmallIcon from 'components/icons/CollectSmallIcon';
import OCCRewardSmallIcon from 'components/icons/OCCRewardSmallIcon';

import config from 'config';
const { OPN_CONTRACT } = config;

export const useFungiblePlantedList = () => {
  const balanceOPN = useAppSelector((state) => {
    // @ts-ignore
    return selectTotalBalance(state, {
      contractName: OPN_CONTRACT
    });
  });

  const plantedOPN = useAppSelector(selectPlantedLockedOPN);
  const unLockedOPN = useAppSelector(selectPlantedUnLockedOPN);
  const plantedWithdrawAt = useAppSelector(selectPlantedWithdrawAt)

  return [
    {
      name: 'balance',
      title: 'Balance OPN',
      icon: BalanceCardSmallIcon,
      amount: balanceOPN,
      textButton: 'Plant OPN'
    },
    {
      name: 'planted',
      title: 'Planted Balance OPN',
      icon: WithdrawSmallIcon,
      amount: plantedOPN,
      textButton: 'Revoke'
    },{
      name: 'withdraw',
      title: 'Locked Balance OPN',
      icon: WithdrawSmallIcon,
      date:plantedWithdrawAt,
      amount: unLockedOPN,
      textButton: 'Withdraw',
      tooltipPosition: 'left',
      tooltipMessage:'Standard Withdrawal: Withdraw OPN tokens after <br /> a 90-day waiting period with no loss. <br /> Fast Withdrawal: Receive tokens immediately,<br /> but 30% will be permanently removed.'
    }
  ];
};

export const useFungiblePlantedRewardList = () => {
  const balanceOPN = useAppSelector((state) => {
    // @ts-ignore
    return selectTotalBalance(state, {
      contractName: OPN_CONTRACT
    });
  });
  const plantedOPN = useAppSelector(selectPlantedOPN);
  return [
    {
      name: 'claim',
      title: 'OPN Delayed Balance:',
      icon: WithdrawSmallIcon,
      amount: balanceOPN,
      textButton: 'Claim OPN'
    },
    {
      name: 'collect',
      title: 'OPN  Balance',
      icon: false,
      amount: plantedOPN,
      textButton: 'Collect OPN Rewards'
    }
  ];
};

export const useFungibleClaimList = () => {
  const availableCollect = useAppSelector(selectCollectAvailable);
  const availableRewards = useAppSelector(selectRewardsAvailable);

  return [
    {
      name: 'collect',
      title: 'Collect Rewards',
      icon: CollectSmallIcon,
      amount: availableCollect,
      textButton: 'Collect OCC',
      tooltipPosition: 'left',
      tooltipMessage:
        'Before you can deposit your OCCs in <br /> the OFP Wallet you must claim them. <br /> Please confirm NEAR Transaction.'
    },
    {
      name: 'rewards',
      title: 'OCC Rewards',
      icon: OCCRewardSmallIcon,
      amount: availableRewards,
      textButton: 'Withdraw OCC',
      tooltipPosition: 'right',
      tooltipMessage: 'Deposits your OCC tokens in the OFP <br /> Wallet.'
    }
  ];
};
